import { Renderer } from './renderer';
import { invokeLifecycle } from './lifecycle';
import { createDialogCancelError } from './dialog-cancel-error';
/**
 * A controller object for a Dialog instance.
 */
var DialogController = (function () {
    /**
     * Creates an instance of DialogController.
     */
    function DialogController(renderer, settings, resolve, reject) {
        this.resolve = resolve;
        this.reject = reject;
        this.settings = settings;
        this.renderer = renderer;
    }
    /**
     * @internal
     */
    DialogController.prototype.releaseResources = function () {
        var _this = this;
        return invokeLifecycle(this.controller.viewModel || {}, 'deactivate')
            .then(function () { return _this.renderer.hideDialog(_this); })
            .then(function () { _this.controller.unbind(); });
    };
    /**
     * @internal
     */
    DialogController.prototype.cancelOperation = function () {
        if (!this.settings.rejectOnCancel) {
            return { wasCancelled: true };
        }
        throw createDialogCancelError();
    };
    /**
     * Closes the dialog with a successful output.
     * @param output The returned success output.
     */
    DialogController.prototype.ok = function (output) {
        return this.close(true, output);
    };
    /**
     * Closes the dialog with a cancel output.
     * @param output The returned cancel output.
     */
    DialogController.prototype.cancel = function (output) {
        return this.close(false, output);
    };
    /**
     * Closes the dialog with an error result.
     * @param message An error message.
     * @returns Promise An empty promise object.
     */
    DialogController.prototype.error = function (message) {
        var _this = this;
        return this.releaseResources().then(function () { _this.reject(message); });
    };
    /**
     * Closes the dialog.
     * @param ok Whether or not the user input signified success.
     * @param output The specified output.
     * @returns Promise An empty promise object.
     */
    DialogController.prototype.close = function (ok, output) {
        var _this = this;
        if (this.closePromise) {
            return this.closePromise;
        }
        return this.closePromise = invokeLifecycle(this.controller.viewModel || {}, 'canDeactivate').catch(function (reason) {
            _this.closePromise = undefined;
            return Promise.reject(reason);
        }).then(function (canDeactivate) {
            if (!canDeactivate) {
                _this.closePromise = undefined; // we are done, do not block consecutive calls
                return _this.cancelOperation();
            }
            return _this.releaseResources().then(function () {
                if (!_this.settings.rejectOnCancel || ok) {
                    _this.resolve({ wasCancelled: !ok, output: output });
                }
                else {
                    _this.reject(createDialogCancelError(output));
                }
                return { wasCancelled: false };
            }).catch(function (reason) {
                _this.closePromise = undefined;
                return Promise.reject(reason);
            });
        });
    };
    return DialogController;
}());
export { DialogController };
/**
 * @internal
 */
DialogController.inject = [Renderer];



//////////////////
// WEBPACK FOOTER
// ./~/aurelia-dialog/dist/native-modules/dialog-controller.js
// module id = 55
// module chunks = 0